<template>
    <div class="chartbox">
        <div id="echart" ref="echart"></div>
         <div class="option">
            <div @click="changeTree(true)" :class="tree?'active':''">树状图</div>
            <div @click="changeTree(false)" :class="!tree?'active':''">森林图</div>
        </div>
    </div>

</template>
<style scoped>
.chartbox{
 background: #fafafa; 
}
  #echart{
    width: 100%;
    min-height: 800px;
  }
    .option{
        width: 280px;
        float : right;
        margin-right: 20px;
    }
    .option div{
        text-decoration: none;
        width: 100px;
        height: 40px;
        background: black;
        border-radius: 40px;
        display: inline-block;
        margin-right: 20px;
        line-height: 40px;
        color: #fff;
        text-align: center;
        margin-bottom: 20px;
        cursor:pointer;
    }
    .option div.active{
        color: #cc8f17;
    }
</style>
<script>
import student from 'service/student-service'
const echarts = require('echarts')
// const service = require('service/student-service')
export default {
  name: 'skilltree',
  data: function () {
    return {
      dataSource: {},
      mapSource: {},
      treeSource: {},
      tree: true,
      option: 'treeSource',
      total: 30
    }
  },
  props: ['treeId'],
  methods: {
    changeTree: function (e) {
      this.tree = e
      // console.log(this.tree)
    }
  },
  watch: {
    tree: function () {
      var that = this
      if (this.tree) {
        this.option = 'treeSource'
        // console.log(this.$refs)
        let ech = this.$refs.echart
        window.onresize = null
        echarts.dispose(ech)
        let myChart = echarts.init(ech)
        // 绘制图表
        myChart.setOption(this.treeSource)
        myChart.on('click', function (params) {
          if (params.data.children.length === 0) {
            that.$router.push('/skill/detail/' + params.data.difficultyId + '?knowledgePointId=' + params.data.knowledgePointId)
          }
        })
        window.onresize = () => {
          myChart.resize()
        }
        myChart.resize()
      } else {
        this.option = 'mapSource'

        let ech = this.$refs.echart
        window.onresize = null
        echarts.dispose(ech)
        let myChart = echarts.init(ech)
        // 绘制图表
        ech.style.height = this.total * 20 + 'px'
        myChart.setOption(this.mapSource)
        window.onresize = () => {
          myChart.resize()
        }
        myChart.resize()
      }
    },
    treeId: function (n) {
      let that = this
      // console.table(r.data)
      if (this.treeId) {
        student.getJsonTree({treeId: this.treeId})
          .then(r => {
            that.dataSource = r.data
            that.total = r.data.total
            that.treeSource = {
              title: {
                text: that.dataSource.name,
                left: 'center'
              },
              // symbol: '/assets/img/symbol/level_02.jpg',
              tooltip: {
                trigger: 'item',
                triggerOn: 'mousemove',
                position: function (point, params, dom, rect, size) {
                  // 固定在顶部
                  return [point[0] - 20, point[1] + 40]
                },
                formatter: function (params) {
                  // console.log(params)
                  if (params.data.children.length) {
                    return '点击查看 ' + params.name + '分支的技能点列表'
                  }
                  return '点击查看' + params.name + '的详情'
                }
              },
              toolbox: {
                right: '5%',
                feature: {
                  saveAsImage: {}
                }
              },
              series: [
                {
                  type: 'tree',
                  initialTreeDepth: 10, // 默认展开几层
                  data: [JSON.parse(that.dataSource.str)[0]],
                  left: '10%',
                  right: '40%',
                  top: '10%',
                  bottom: '10%',
                  // symbol: '/assets/img/symbol/level_02.jpg',
                  symbol: 'emptyCircle',
                  symbolSize: 12,
                  // orient: 'vertical',
                  lineStyle: {
                    normal: {
                      curveness: 0.7
                    }
                  },
                  label: {
                    normal: {
                      position: 'right',
                      rotate: 0,
                      verticalAlign: 'center',
                      align: 'left',
                      fontSize: 12,
                      offset: [0, 0],
                      padding: 4
                    }
                  },
                  leaves: {
                    label: {
                      normal: {
                        // position: 'bottom',
                        // rotate: 0,
                        // verticalAlign: 'middle',
                        // align: 'right',
                        // fontSize: 12,
                        // offset: [20, -10]
                      }
                    }
                  },
                  animationDurationUpdate: 750
                }
              ]
            }
            that.mapSource = {
              title: {
                text: '技能树',
                left: 'center'
              },
              toolbox: {
                right: '5%',
                feature: {
                  saveAsImage: {}
                }
              },
              series: [
                {
                  name: that.dataSource.name,
                  type: 'sunburst',
                  highlightPolicy: 'ancestor',
                  // label: {
                  //   show: true
                  // },
                  left: '40%',
                  right: '40%',
                  top: '20%',
                  bottom: '20%',
                  radius: [0, '95%'],
                  sort: null,
                  levels: [
                    {},
                    {
                      r0: '15%',
                      r: '35%',
                      itemStyle: {
                        borderWidth: 2
                      },
                      label: {
                        rotate: 'tangential'
                      }
                    },
                    {
                      r0: '35%',
                      r: '72%',
                      label: {
                        align: 'right',
                        position: 'outside',
                        padding: 3,
                        silent: false
                      }
                    },
                    {
                      r0: '72%',
                      r: '80%',
                      label: {
                        align: 'right',
                        position: 'outside',
                        padding: 3,
                        silent: false
                      }
                    }
                  ],
                  data: JSON.parse(that.dataSource.str)[0].children
                }
              ]
            }
            let ech = that.$refs.echart
            window.onresize = null
            echarts.dispose(ech)
            let myChart = echarts.init(ech)
            // 绘制图表
            ech.style.height = this.total * 20 + 'px'
            myChart.setOption(that[that.option])
            if (this.option === 'treeSource') {
              myChart.on('click', function (params) {
                if (params.data.children.length === 0) {
                  that.$router.push('/skill/detail/' + params.data.difficultyId + '?knowledgePointId=' + params.data.knowledgePointId)
                }
              })
            }
            window.onresize = () => {
              myChart.resize()
            }
            myChart.resize()
          })
      }
    }
  },
  mounted: function () {
    let that = this
    if (this.treeId) {
      student.getJsonTree({treeId: this.treeId})
        .then(r => {
          // console.log(r.data)
          that.dataSource = r.data
          that.total = r.data.total
          that.treeSource = {
            title: {
              text: that.dataSource.name,
              left: 'center'
            },
            toolbox: {
              right: '5%',
              feature: {
                saveAsImage: {}
              }
            },
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              position: function (point, params, dom, rect, size) {
                // 固定在顶部
                return [point[0] - 20, point[1] + 40]
              },
              formatter: function (params) {
                // console.log(params)
                if (params.data.children.length) {
                  return '点击查看 ' + params.name + '分支的技能点列表'
                }
                return '点击查看' + params.name + '的详情'
              }
            },
            series: [
              {
                type: 'tree',
                initialTreeDepth: 10, // 默认展开几层
                data: [JSON.parse(that.dataSource.str)[0]],
                left: '10%',
                right: '40%',
                top: '10%',
                bottom: '10%',
                symbol: 'emptyCircle',
                symbolSize: 12,
                // symbol: 'image:///assets/img/symbol/level_02.jpg',
                // symbol: 'image://static/img/symbol/level_01.png',
                // symbolSize: [20, 20],
                // showAllSymbol: true,
                // orient: 'vertical',
                lineStyle: {
                  normal: {
                    curveness: 0.7
                  }
                },
                label: {
                  normal: {
                    position: 'right',
                    rotate: 0,
                    verticalAlign: 'center',
                    align: 'left',
                    fontSize: 12,
                    offset: [0, 0],
                    padding: 4
                  }
                },
                leaves: {
                  label: {
                    normal: {
                      // position: 'bottom',
                      // rotate: 0,
                      // verticalAlign: 'middle'
                      // align: 'right',
                      // fontSize: 12,
                      // offset: [20, -10],
                      // padding: 10
                    }
                  }
                },
                animationDurationUpdate: 750
              }
            ]
          }
          that.mapSource = {
            title: {
              text: '技能树',
              left: 'center'
            },
            toolbox: {
              right: '5%',
              feature: {
                saveAsImage: {}
              }
            },
            series: [
              {
                name: that.dataSource.name,
                type: 'sunburst',
                highlightPolicy: 'ancestor',
                // label: {
                //   show: true
                // },
                left: '30%',
                right: '30%',
                top: '20%',
                bottom: '20%',
                radius: [0, '95%'],
                sort: null,
                levels: [
                  {},
                  {
                    r0: '15%',
                    r: '35%',
                    itemStyle: {
                      borderWidth: 2
                    },
                    label: {
                      rotate: 'tangential'
                    }
                  },
                  {
                    r0: '35%',
                    r: '72%',
                    label: {
                      position: 'outside',
                      padding: 3,
                      silent: false
                    }
                  },
                  {
                    r0: '72%',
                    r: '80%',
                    label: {
                      align: 'right',
                      position: 'outside',
                      padding: 3,
                      silent: false
                    }
                  }
                ],
                data: JSON.parse(that.dataSource.str)[0].children
              }
            ]
          }
          let ech = that.$refs.echart
          window.onresize = null
          echarts.dispose(ech)
          let myChart = echarts.init(ech)
          // 绘制图表
          // ech.style.width = this.width + 'px'
          ech.style.height = this.total * 20 + 'px'
          // console.log(ech.style.height)
          myChart.setOption(that[that.option])
          if (this.option === 'treeSource') {
            myChart.on('click', function (params) {
              if (params.data.children.length === 0) {
                that.$router.push('/skill/detail/' + params.data.difficultyId + '?knowledgePointId=' + params.data.knowledgePointId)
              }
            })
          }
          window.onresize = () => {
            myChart.resize()
          }
          myChart.resize()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/skill-tree/skill-tree.vue